import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Organisation from '../Organisation/Organisation';
import SearchHeader from '../SearchHeader/SearchHeader';

const propTypes = {
  results: PropTypes.array.isRequired,
  searchTerm: PropTypes.string,
  currentPage: PropTypes.number,
  handleChange: PropTypes.func,
  handlePageChange: PropTypes.func,
};

export default function Results(
  props: InferProps<typeof propTypes>,
): JSX.Element {
  const { results, searchTerm, currentPage, handleChange, handlePageChange } =
    props;

  const paginationNumbers = [];

  for (let i = 1; i <= Math.ceil(results.length / 10); i++) {
    paginationNumbers.push(i);
  }

  const paginatedResults = results.slice(
    (currentPage - 1) * 10,
    (currentPage - 1) * 10 + 10,
  );

  return (
    <div>
      <Row>
        <Col>
          <SearchHeader
            count={results.length}
            searchTerm={searchTerm}
            handleChange={handleChange}
          />
        </Col>
      </Row>

      <Row>
        <Col md={{ span: 12, offset: 0 }}>
          {paginatedResults.map(({ data }, index) => (
            <Organisation
              key={data.canonicalName}
              name={data.name}
              teReoName={data.teReoName}
              description={data.description}
              contactEmail={data.contactEmail}
              pdfName={data.pdfName}
              pdfLink={data.pdfLink}
            />
          ))}
        </Col>
      </Row>

      <Row>
        {paginationNumbers.length > 1 && (
          <ul className="pagination">
            {paginationNumbers.map((pageNumber) => (
              <li key={`pagination-${pageNumber}`}>
                <button
                  className={`pagination__link ${pageNumber == currentPage ? 'current' : ''}`}
                  value={pageNumber}
                  onClick={handlePageChange}
                >
                  {pageNumber}
                </button>
              </li>
            ))}
          </ul>
        )}
      </Row>
    </div>
  );
}
